// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--qIMkx","card":"card--E3UYS","cardBox":"cardBox--hVO+b","cardIcon":"cardIcon--PCcND","titleBilling":"titleBilling--5iZ3d","accent":"accent--7d1y6"};